import styled from 'styled-components';
import { Toolbar } from "@material-ui/core";
import { NavLink, Link } from "react-router-dom";
import { DesktopToolbarStyleProps } from './DesktopToolbar.interface';

export const Logo = styled.img`
  height: 30px;
`;

export const StyledToolbar = styled(Toolbar)<DesktopToolbarStyleProps>`
  && {
    max-width: ${props => props.adminAccess ? '1300px' : '1232px'};
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;

export const StyledButton = styled(Link)`
  && {
    text-transform: uppercase;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.blue};
    padding: ${({ theme }) => theme.spacing * 4}px
      ${({ theme }) => theme.spacing * 6}px;
    text-decoration: none;
    margin: 0 ${({ theme }) => theme.spacing * 3}px
      0 ${({ theme }) => theme.spacing * 4}px; 
  }
`;

export const Button = styled.button`
  text-transform: uppercase;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blue};
  padding: ${({ theme }) => theme.spacing * 4}px
    ${({ theme }) => theme.spacing * 6}px;
  margin: 0 ${({ theme }) => theme.spacing * 3}px
    0 ${({ theme }) => theme.spacing * 4}px; 
  border: none;
  outline: none;
  cursor: pointer;
`;

const activeClassName = 'active';

export const StyledLink = styled(NavLink).attrs({ activeClassName })`
  margin: 0 ${({ theme }) => theme.spacing * 4}px;
  color: ${({ theme }) => theme.colors.white};
  text-transform: uppercase;
  text-decoration: none;
  font-size: 12px;
  font-weight: bold;
  height: 44px;
  line-height: 44px;
  padding: ${({ theme }) => theme.spacing * 4}px ${({ theme }) => theme.spacing * 5}px;
  &:hover {
    color: #8de8ff;
  }
  &.${activeClassName} {
    border-radius: 6px;
    background-color: #ffffff1a;
    &:hover {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const StyleListElement = styled.span`
  color: ${({ theme }) => theme.colors.white};
  margin: 0 ${({ theme }) => theme.spacing * 4}px;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    color: #8de8ff;
  }
`;

export const DisabledButton = styled.p`
  display: inline-block;
  text-transform: uppercase;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blue};
  padding: ${({ theme }) => theme.spacing * 4}px
    ${({ theme }) => theme.spacing * 6}px;
  text-decoration: none;
  margin: 0 ${({ theme }) => theme.spacing * 3}px
    0 ${({ theme }) => theme.spacing * 4}px; 
  opacity: .38;
  border: none;
  outline: none;
  cursor: pointer;
`;
